import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
const testimonials = [{
  name: 'Martín González',
  age: 24,
  city: 'Buenos Aires',
  text: 'Antes entrenaba sin rumbo. Con este sistema mejoré mi tiro un montón y ahora me siento mucho más confiado en los partidos. Lo recomiendo 100%.',
  rating: 5
}, {
  name: 'Lucas Fernández',
  age: 19,
  city: 'Córdoba',
  text: 'La parte de físico específico me cambió el juego. Ya no me canso en el último cuarto y puedo rendir al máximo todo el partido.',
  rating: 5
}, {
  name: 'Santiago Rodríguez',
  age: 28,
  city: 'Rosario',
  text: 'Los módulos tácticos son oro puro. Ahora tomo mejores decisiones en tiempo real y mi juego sin balón mejoró muchísimo.',
  rating: 5
}, {
  name: 'Nicolás Pérez',
  age: 22,
  city: 'Mendoza',
  text: 'El plan de 8 semanas es súper claro y fácil de seguir. En dos meses vi cambios reales en mi juego. Vale cada peso.',
  rating: 5
}, {
  name: 'Facundo López',
  age: 31,
  city: 'La Plata',
  text: 'Juego hace años pero nunca había entrenado con un sistema tan completo. Los bonos son un regalo, especialmente la planilla de seguimiento.',
  rating: 5
}];
export function Testimonials() {
  return <section className="w-full bg-blue-50 py-12 md:py-16 px-4" data-id="element-184">
      <div className="max-w-6xl mx-auto" data-id="element-185">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-10" data-id="element-186">
          Lo que dicen los jugadores
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-187">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white p-6 rounded-lg shadow-md" data-id="element-188">
              <div className="flex gap-1 mb-3" data-id="element-189">
                {[...Array(testimonial.rating)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-orange-500 text-orange-500" data-id="element-190" />)}
              </div>
              <p className="text-gray-700 mb-4 italic" data-id="element-191">"{testimonial.text}"</p>
              <div className="border-t pt-4" data-id="element-192">
                <p className="font-bold text-gray-900" data-id="element-193">{testimonial.name}</p>
                <p className="text-sm text-gray-600" data-id="element-194">
                  {testimonial.age} años • {testimonial.city}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}